<template>
  <div
    v-if="gotModuleData"
    class="container max-w-screen-3xl border-t border-b border-htz-lightgrey"
    :class="moduleInfo.Module.CssClass"
  >
    <div
      v-if="elementsToShowInNav.length"
      class="tab-nav-slider-container"
    >
      <div class="tab-nav-slider-container-inner relative w-full bg-white lg:flex lg:justify-left lg:items-center max-w-screen-xl">
        <!-- <div class="fadeout-left" /> -->
        <div class="fadeout-right" />
        <swiper
          ref="tabBarSwiper"
          free-mode="true"
          free-mode-sticky="true"
          free-mode-momentum-ratio="0.25"
          free-mode-velocity-ratio="0.25"
          free-mode-minimum-velocity="0.1"
          mousewheel-control="true"
          mousewheel-sensitivity="0.5"
          slide-to-clicked-slide="true"
          slides-per-view="auto"
          touch-ratio="0.2"
          class="tab-nav-slider"
          @swiper="onSwiper"
        >
          <swiper-slide
            v-for="(moduleData, index) in elementsToShowInNav.filter((obj) => obj.Module.EntityID != moduleInfo.Module.EntityID)"
            :key="moduleData.Module.EntityID"
            class="w-auto"
          >
            <ul>
              <li>
                <a
                  v-if="elementNamesToShowInNav"
                  :href="'#' + moduleData.Module.EntityID"
                  @click="scrollToItem(moduleData.Module.EntityID, $event)"
                >
                  {{ elementNamesToShowInNav[index] ? elementNamesToShowInNav[index] : $filters.getPropertyValue(  $t, "ModuleTitle", moduleData.Module.ModuleProperties, moduleData.Module) }}
                </a>
              </li>
            </ul>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="loader" />
  </div>
</template>

<script>
import {selfDataRequestMixin} from "@/mixins";
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";
import { swiperListOptions } from "@/services/swiperOptions";

import "swiper/swiper.scss";

export default {
  name: "TabBar",
  components: {
    Swiper,
    SwiperSlide,
  },
  mixins: [selfDataRequestMixin],
  props: {
    moduleInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
        isActive: true,
        swiper: {},
        swiperListOptions: {...swiperListOptions},
        display: "desktop",
        flag: false,
        elementsToShowInNav: []

    };
  },
  computed: {
    gotModuleData() {
      let navElementsId = [];
      let navElementsNames = [];
      if(this.$filters.hasPropertyValue( 'ModuleNavElements',this.moduleInfo.Module.ModuleProperties,this.moduleData)){
        const navElementsProperty = this.$filters.getPropertyValue(this.$t, "ModuleNavElements",this.moduleInfo.Module.ModuleProperties,this.moduleData);
        if(navElementsProperty != '') {
          navElementsId = navElementsProperty.split("#");
        }
      }
      this.addElementsToNavigation(navElementsId);
      return !!this.$store.state.PageData.ModuleData.length;
    }
  },
  mounted() {
    this.$store.state.forceLoadAllModule = true;
    this.windowWidth();
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.windowWidth);

  },
  unmounted(){
    document.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener("resize", this.windowWidth);

  },
  methods: {
    scrollToItem(entityId, e){
      e.preventDefault();
      window.scrollBy(0, 1);
      setTimeout(() => {
        var tabElements = document.querySelectorAll(".tab-nav-slider .swiper-slide li a");
        setTimeout(() => {
          [].forEach.call(tabElements, function (el) {
            el.classList.remove("active");
          });
          e.target.classList.add("active");
        }, 800);
        const elmnt = document.getElementById(entityId);
        if (elmnt) {
          elmnt.scrollIntoView();
        }
      },50)

    },
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    handleScroll() {

          //handle fixed tab nav
          if(document.querySelector(".tab-nav-slider-container")){
            const tabNavSlider = document.querySelector(".tab-nav-slider-container-inner");
            const tabNavSliderTop =  document.querySelector(".tab-nav-slider-container").offsetTop;
            const navContainerHeight = document.querySelector(".nav-container").offsetHeight; //120

            setTimeout(() => {
              if (window.scrollY < tabNavSliderTop) {
                tabNavSlider.classList.remove("tab-nav-slider-fixed");
              }else if (window.scrollY > tabNavSliderTop - navContainerHeight) {
                tabNavSlider.classList.add("tab-nav-slider-fixed");
              }else {
                tabNavSlider.classList.remove("tab-nav-slider-fixed");
              }
            }, 400);
          }

          //handle active tab nav mobile
          const observer = new IntersectionObserver(entries => {

            entries.forEach(entry => {
              const ratio = entry.intersectionRatio;
              const boundingRect = entry.boundingClientRect;
              const intersectionRect = entry.intersectionRect;
              const id = entry.target.getAttribute('id');
              let activeTabNav = document.querySelector(`.tab-nav-slider .swiper-wrapper .swiper-slide li a[href="#${id}"]`);

              if (activeTabNav && ratio === 0) {//outside
                activeTabNav.classList.remove('active');
              }
              else if (activeTabNav && ratio < 0.75) {
                if (boundingRect.top < intersectionRect.top) {//top
                    activeTabNav.classList.add('active');
                }
                else {//bottom
                    activeTabNav.classList.remove('active');
                }
              } else if(activeTabNav){//inside
                activeTabNav.classList.add('active');

              }
            });
          }, io_options);

          const io_options = {
            root: null,
            rootMargin: '0px 0px -50% 0px',
            threshold: 0.5
          };

          // Track all sections with scroll-margin class that have an `id` applied and for each call observer
          let sections = document.querySelectorAll('.scroll-margin-default[id]');
          if(sections){
            sections.forEach((section) => {
              observer.observe(section);
            });
          }


    },

    windowWidth() {
      if (window.innerWidth > 640) {
        this.display = "desktop";
      } else {
        this.display = "mobile";
        if(this.flag === false){
          this.flag = true;
        }
      }
    },
    addElementsToNavigation(navElemetsIdArr){
      if(navElemetsIdArr.length && this.$store.state.PageData.ModuleData.length){
         let navElementsNames;
        if(this.$filters.hasPropertyValue("ModuleNavElementsNames",this.moduleInfo.Module.ModuleProperties,this.moduleData)){
          navElementsNames = this.$filters.getPropertyValue(this.$t, "ModuleNavElementsNames",this.moduleInfo.Module.ModuleProperties,this.moduleData);
          navElementsNames = navElementsNames.split("#").map(str => this.$t(str.replaceAll('%', '')));
        }
        this.elementNamesToShowInNav = navElementsNames;
        this.elementsToShowInNav = this.$store.state.PageData.ModuleData.filter((obj) => navElemetsIdArr.includes(obj.Module.EntityID.toString()))
      }
    },
  }
};
</script>

<style lang="scss" scoped>

.tab-nav-slider-container {
  @apply min-h-20 max-w-screen-xl mx-auto;
  @screen md{
    @apply min-h-24;
  }
}
.tab-nav-slider{
  @apply mx-auto mx-0 max-w-screen-xl min-h-20 bg-white flex items-center justify-center flex-wrap py-3 pr-24 transition-all duration-300 ease-in-out;
  @screen sm{
    @apply min-h-24;
  }
  .swiper-slide{width: auto !important; opacity: 1;}
  li a{
    @apply w-full h-full block text-htz-blue uppercase font-livory text-14 font-livory-bold px-4 transition-all duration-100 ease-in-out;
    letter-spacing: 1px;
    @screen sm{
      @apply text-15;
    }
    &:after {
      content: "";
      display: block;
      height: 1px;
      width: 100%;
    }
    &:hover, &:active{
      @apply text-htz-red;
    }

  }
  li a.active{
    @apply text-htz-red;
    &:after {
      content: "";
      @apply bg-htz-red;
    }
  }
}
.tab-nav-slider-container-inner:not(.tab-nav-slider-fixed) .swiper-slide{
  li a{
    @apply text-htz-blue;
    &:hover, &:active{
      @apply text-htz-red;
    }
  }
  li a.active{
    @apply text-htz-red;
    &:after {
      content: "";
      @apply bg-htz-red;
    }
  }
  &:first-child li a{
       @apply text-htz-red;
  }
}



.tab-nav-slider-fixed{
  @apply fixed z-30 left-0 right-0 w-full max-w-screen-3xl;
  top: 64px;
  .tab-nav-slider{
    @apply w-full mx-auto max-w-screen-xl;
  }
}

.fadeout-right{
    z-index: 8;
    position: absolute;
    left: auto;
    right:0;
    top: 0;
    height: 100%;
    width: 100px;
    display: block;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 10%, rgba(255, 255, 255, 0.5) 20%, rgba(255, 255, 255, 0.8) 50%, #fff);
    @screen lg{
      display: block;
    }
}
.fadeout-left{
    z-index: 8;
    position: absolute;
    left: 0;
    right:auto;
    top: 0;
    height: 100%;
    width: 100px;
    display: block;
    background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 10%, rgba(255, 255, 255, 0.5) 20%, rgba(255, 255, 255, 0.8) 50%, #fff);
    @screen lg{
      display: block;
    }
}
</style>
